import { render, staticRenderFns } from "./gatewayProxy.vue?vue&type=template&id=137d376e&scoped=true&"
import script from "./gatewayProxy.vue?vue&type=script&lang=js&"
export * from "./gatewayProxy.vue?vue&type=script&lang=js&"
import style0 from "./gatewayProxy.vue?vue&type=style&index=0&id=137d376e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d376e",
  null
  
)

export default component.exports